export class UnansweredMandatoryQuestionsError extends Error {
  constructor(...params: any[]) {
    super(...params);
    Object.setPrototypeOf(this, UnansweredMandatoryQuestionsError.prototype);
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, UnansweredMandatoryQuestionsError);
    this.name = 'UnansweredMandatoryQuestionsError';
  }
}

export class SubmissionFailedError extends Error {
  constructor(...params: any[]) {
    super(...params);
    Object.setPrototypeOf(this, SubmissionFailedError.prototype);
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, SubmissionFailedError);
    this.name = 'SubmissionFailedError';
  }
}
